<template>
  <div class="card-link-convite">
    <div class="card-header-link">
      <i class="fas fa-link icon-link"></i>
      <h6>Seu link de convite</h6>
    </div>

    <div class="row-link">
      <input
        type="text"
        readonly
        :value="linkCompleto"
        ref="inputLink"
        @click="selecionarTudo"
      />
      <button class="btn-copiar" @click="copiar" :disabled="!codigoIndicacao">
        <i :class="copiado ? 'fas fa-check' : 'far fa-copy'"></i>
        {{ copiado ? 'Copiado!' : 'Copiar' }}
      </button>
    </div>

    <div v-if="codigoIndicacao" class="row-acoes">
      <span class="chip-codigo">
        <strong>Seu código:</strong> <code>{{ codigoIndicacao }}</code>
      </span>
      <a :href="linkWhatsapp" target="_blank" rel="noopener" class="btn-whats">
        <i class="fab fa-whatsapp"></i>
        Compartilhar no WhatsApp
      </a>
    </div>

    <p v-if="!codigoIndicacao" class="aviso">
      <i class="fas fa-exclamation-triangle me-1"></i>
      Seu código ainda não foi gerado. Peça ao gestor para sincronizar os treinadores do Laravel.
    </p>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'

const props = defineProps({
  codigoIndicacao: { type: String, default: null },
  nomeConvidante: { type: String, default: 'seu treinador' },
})

const copiado = ref(false)
const inputLink = ref(null)

const baseUrlPublica = computed(() => {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
})

const linkCompleto = computed(() => {
  if (!props.codigoIndicacao) return 'Carregando...'
  return `${baseUrlPublica.value}/cadastro?ref=${props.codigoIndicacao}`
})

const mensagemWhats = computed(() => {
  const texto = `Ola! Venha fazer parte da minha rede no Diario de Treino. Cadastre-se pelo link: ${linkCompleto.value}`
  return encodeURIComponent(texto)
})

const linkWhatsapp = computed(() => `https://wa.me/?text=${mensagemWhats.value}`)

async function copiar() {
  if (!props.codigoIndicacao) return
  try {
    await navigator.clipboard.writeText(linkCompleto.value)
    copiado.value = true
    setTimeout(() => { copiado.value = false }, 2000)
  } catch {
    selecionarTudo()
  }
}

function selecionarTudo() {
  inputLink.value?.select()
}
</script>

<style scoped>
.card-link-convite {
  background: linear-gradient(135deg, #5e72e4 0%, #825ee4 100%);
  border-radius: 14px;
  padding: 18px 22px;
  color: #fff;
  box-shadow: 0 4px 16px rgba(94, 114, 228, 0.25);
  margin-bottom: 20px;
}

.card-header-link {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.card-header-link h6 {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
}
.icon-link {
  font-size: 1.1rem;
  opacity: 0.95;
}

.row-link {
  display: flex;
  gap: 10px;
  align-items: center;
}
.row-link input {
  flex: 1;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 10px 14px;
  color: #fff;
  font-size: 0.88rem;
  font-family: 'Courier New', monospace;
}
.row-link input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.25);
}
.row-link input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.btn-copiar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #5e72e4;
  border: none;
  padding: 10px 14px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
  white-space: nowrap;
  transition: all 0.15s;
}
.btn-copiar:hover:not(:disabled) {
  background: #f8f9fa;
  transform: translateY(-1px);
}
.btn-copiar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-copiar i {
  font-size: 0.9rem;
}

.row-acoes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.chip-codigo {
  font-size: 0.85rem;
  opacity: 0.95;
}
.chip-codigo code {
  background: rgba(255, 255, 255, 0.2);
  padding: 3px 10px;
  border-radius: 4px;
  color: #fff;
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

.btn-whats {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #22c55e;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.15s;
}
.btn-whats:hover {
  background: #16a34a;
  color: #fff;
  transform: translateY(-1px);
}
.btn-whats i {
  font-size: 1rem;
}

.aviso {
  margin-top: 10px;
  padding: 10px 14px;
  background: rgba(251, 191, 36, 0.2);
  border-radius: 6px;
  font-size: 0.85rem;
  color: #fef3c7;
  margin-bottom: 0;
}
</style>
